import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { GetStartedTaskProperty } from '../interfaces/GetStartedTaskProperty';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { isGetStartedInListViewEnabled } from '../selectors/isGetStartedInListViewEnabled';
import { isGetStartedPhoneCardEnabled } from '../selectors/isGetStartedPhoneCardEnabled';
import { isGetStartedOfficeCardEnabled } from '../selectors/isGetStartedOfficeCardEnabled';
import { isGetStartedPersonalizationEnabled } from '../selectors/isGetStartedPersonalizationEnabled';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isEdu } from 'owa-nonboot-userconfiguration-manager';

import { openTimeZoneSetting } from '../actions/openTimeZoneSetting';
import { openPremiumUpsell } from '../actions/openPremiumUpsell';
import { downloadMobile } from '../actions/downloadMobile';
import { importContact } from '../actions/importContact';
import { sendAnEmail } from '../actions/sendAnEmail';
import { addStorageAccount } from '../actions/addStorageAccount';
import { showPhoneAppCard } from '../actions/showPhoneAppCard';
import { showOfficeAppCard } from '../actions/showOfficeAppCard';
import { showPersonalizationModal } from '../actions/showPersonalizationModal';

import {
    task_Confirm_Timezone,
    task_Import_Contacts,
    task_Send_Email,
    task_Get_Mobile,
    task_Upgrade_Premium,
    task_Free_Office_Apps,
    task_Add_Storage_Account,
    task_Customize_The_Look,
} from '../getStarted.locstring.json';

const ConfirmTimeZoneTask = {
    identity: GetStartedTaskId.ConfirmTimeZone,
    icon: ControlIcons.Globe,
    text: loc(task_Confirm_Timezone),
    onClick: openTimeZoneSetting,
};

const ImportContactTask = {
    identity: GetStartedTaskId.ImportContact,
    icon: ControlIcons.People,
    text: loc(task_Import_Contacts),
    onClick: importContact,
};

const SendAnEmailTask = {
    identity: GetStartedTaskId.SendAnEmail,
    icon: ControlIcons.Send,
    text: loc(task_Send_Email),
    onClick: sendAnEmail,
};

const DownloadMobileTask = {
    identity: GetStartedTaskId.DownloadMobile,
    icon: ControlIcons.CellPhone,
    text: loc(task_Get_Mobile),
    onClick: isGetStartedPhoneCardEnabled() ? showPhoneAppCard : downloadMobile,
};

const PremiumUpsellTask = {
    identity: GetStartedTaskId.PremiumUpsell,
    icon: ControlIcons.Diamond,
    text: loc(task_Upgrade_Premium),
    onClick: openPremiumUpsell,
};

const ShowOfficeAppsTask = {
    identity: GetStartedTaskId.ShowOfficeApps,
    icon: ControlIcons.Waffle,
    text: loc(task_Free_Office_Apps),
    onClick: showOfficeAppCard,
};

const AddStorageAccountTask = {
    identity: GetStartedTaskId.AddStorageAccount,
    icon: ControlIcons.CloudAdd,
    text: loc(task_Add_Storage_Account),
    onClick: addStorageAccount,
};

const CustomizeTheLookTask = {
    identity: GetStartedTaskId.CustomizeTheLook,
    icon: ControlIcons.Color,
    text: loc(task_Customize_The_Look),
    onClick: showPersonalizationModal,
};

export function getGetStartedTaskProperties(): Array<GetStartedTaskProperty> {
    let taskPropertiesForMessageListConsumer: Array<GetStartedTaskProperty> = [
        ConfirmTimeZoneTask,
        ImportContactTask,
        SendAnEmailTask,
        DownloadMobileTask,
        PremiumUpsellTask,
    ];

    let taskPropertiesForMessageListEdu: Array<GetStartedTaskProperty> = [
        SendAnEmailTask,
        ShowOfficeAppsTask,
        DownloadMobileTask,
        AddStorageAccountTask,
        ImportContactTask,
    ];

    if (isGetStartedOfficeCardEnabled()) {
        taskPropertiesForMessageListConsumer.push(ShowOfficeAppsTask);
    }

    if (isGetStartedPersonalizationEnabled()) {
        taskPropertiesForMessageListConsumer.splice(0, 0, CustomizeTheLookTask);
        taskPropertiesForMessageListEdu.splice(0, 0, CustomizeTheLookTask);
    }

    if (isGetStartedInListViewEnabled()) {
        if (isConsumer()) {
            return taskPropertiesForMessageListConsumer;
        } else if (isEdu()) {
            return taskPropertiesForMessageListEdu;
        }
    }

    return [];
}
